import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const SetupCenter = React.lazy(() => import("./SetupCenter.view"));

const SetupCenterLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <SetupCenter />
  </React.Suspense>
);

export default SetupCenterLoadable;
